(function (factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['./jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('./jquery'));
    } else {
        factory(jQuery);
    }
}(function ($) {
    $(document).ready(function () {
        initTableSettings();

        // For Sending email
        // Attach a submit handler to the form
        $("#FormSendComment").submit(function (event) {

            // Stop form from submitting normally
            event.preventDefault();

            // Get some values from elements on the page:
            var url = $("#FormSendComment").attr("action");
            var formData = $("#FormSendComment").serialize();

            $('#divProgress').removeClass("hide");
            $("#FormSendComment").addClass("hide");
            $('#divError').addClass("hideme");

            var jqxhr = $.post(url,
                formData,
                function () {

                })
                .success(function () {
                    $('#divProgress').addClass("hide");
                    $('#divSuccessful').removeClass("hide");
                })
                .error(function () {
                    $('#divProgress').addClass("hide");
                    $('#divError').removeClass("hideme"); // Display Error
                    $('#FormSendComment').removeClass("hide");
                });
            return false;
        });

        $('.js-cad-visualize-link').on('click',
            function (e) {
                e.preventDefault();

                var designation = $(this).attr('data-designation');
                UpdateCADIframe(designation, "", $(".js-origin-link").val(), true);
                var cadIframeTopPosition = $('#js-cad-iframe').offset().top;
                window.scrollTo(0, cadIframeTopPosition - 200);
            });
    });

    function initTableSettings() {
        $(window).on('load', function () {
            var settingsPopup = $(".tablesaw-columntoggle-popup .btn-group");

            if (settingsPopup.length > 0) {
                var selectAllCheckbox = settingsPopup.find("label:first-child").find("input[type=checkbox]");

                selectAllCheckbox.on("change",
                    function () {
                        var checkbox = $(this);

                        if (checkbox.is(':checked')) {
                            setCheckedState(checkbox, true);
                        } else {
                            setCheckedState(checkbox, false);
                        }
                    });
                selectAllCheckbox.prop('checked', true).trigger("change");
            }
        })
    }

    function UpdateCADIframe(designation, orderCode, origin, openCadArea = false) {
        var cadVisualzerInput = $('#cad-visualizer');

        //Open cad visualizer tab
        if (!cadVisualzerInput.is(':checked') && openCadArea) {
            $('#cad-visualizer').trigger("click");
        }

        //Set cad visualizer src
        var iframe = $('#js-cad-iframe');
        if (iframe[0] != undefined) {
            var srcBase = iframe.attr('data-src');
            iframe[0].contentWindow.location.replace(srcBase + "?designation=" + designation + "&order-code=" + orderCode + "&qUrl=" + origin);
        }
    }

    function UpdateArticleCADIframe(designation, origin) {
        // Set article cad visualizer src
        var iframe = $('#js-article-cad-iframe');
        if (iframe[0] != undefined) {
            var srcBase = iframe.attr('data-src');
            iframe[0].contentWindow.location.replace(srcBase + "?designation=" + designation + "&qUrl=" + origin);
        }
    }

    function setCheckedState(checkbox, checked) {

        var checkboxes = checkbox.parents(".btn-group").find("input[type=checkbox]");
        var index = 0;

        if (checked) {
            checkboxes.each(function () {
                if (index > 0) {
                    $(this).prop('checked', checked).trigger("change");
                }
                index++;
            });
        } else {
            checkboxes.each(function () {
                if (index > 0) {
                    if (index <= 5) {
                        $(this).prop('checked', true).trigger("change");
                    } else {
                        $(this).prop('checked', false).trigger("change");
                    }
                }
                index++;
            });
        }
    }
}));